import LoginForm from '@/model/user/LoginForm'
import axios from '@/axios'
import LoginRequest from '@/model/user/LoginRequest'
import StorageKeyDefineLogin from '@/define/storage/login'
import UrlDefineBase from '@/define/url/UrlDefineBase'
import $store from '@/store'
import NameUtil from '@/utils/NameUtil'
import StoreDefineLogin from '@/define/store/user/login'

export default class LoginService {
  public static login(loginForm: LoginForm) {
    return new Promise((resolve, reject) => {
      axios.post(UrlDefineBase.LOGIN, new LoginRequest(loginForm))
        .then((resp) => {
          if (loginForm.rememberPassword) {
            localStorage[StorageKeyDefineLogin.LOGIN_FORM_CACHE] = JSON.stringify(loginForm)
          }
          sessionStorage[StorageKeyDefineLogin.LOGIN_TOKEN] = resp.data.body.token
          sessionStorage[StorageKeyDefineLogin.LOGIN_USER_ID] = resp.data.body.id
          sessionStorage[StorageKeyDefineLogin.LOGIN_USER_GROUP] = resp.data.body.group
          axios.defaults.headers = {
            token: resp.data.body.token
          }
          this.setStoreLoginState(true)
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  private static setStoreLoginState(loginState: boolean) {
    $store.commit(NameUtil.CSCK(StoreDefineLogin.SET_LOGIN_STATE), loginState)
  }

  static logout() {
    sessionStorage.removeItem(StorageKeyDefineLogin.LOGIN_TOKEN)
    localStorage.removeItem(StorageKeyDefineLogin.LOGIN_TOKEN)
    this.setStoreLoginState(false)
  }

  public static getAccessToken(): string {
    return sessionStorage[StorageKeyDefineLogin.LOGIN_TOKEN]
  }

  static getLoginState() {
    const loginToken = sessionStorage[StorageKeyDefineLogin.LOGIN_TOKEN]
    const loginState = loginToken !== undefined
    if (loginState) {
      axios.defaults.headers = {
        token: loginToken
      }
    }
    this.setStoreLoginState(loginState)
    return loginState
  }

  static getLoginFormCache(): LoginForm {
    const loginFormCacheStr = localStorage[StorageKeyDefineLogin.LOGIN_FORM_CACHE]
    if (loginFormCacheStr === undefined) {
      return new LoginForm()
    }
    return JSON.parse(loginFormCacheStr)
  }
}
